import { useDispatch } from 'react-redux'
import { useFirebaseEvent } from 'hooks'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY, FIREBASE_EVENTS, PORTAL_NEGOTIATION_LINK } from 'app-constants'
import { InfoCard } from 'components'
import { STATICS } from 'statics'
import './style.scss'

export function DashboardCanceledContract() {
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  function handleNegotiationRequest() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_CANCELED_CONTRACT_NEGOTIATION_BILLS)
    dispatch(setDrawer(DRAWER_KEY.NEGOTIATION))
  }

  function handleNegotiationPortalRedirect() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_NEGOTIATION_PORTAL)
    window.open(PORTAL_NEGOTIATION_LINK, '_blank')
  }

  function renderNegotiationRequest() {
    return (
      <InfoCard
        title='Negociar Faturas'
        actions={[
          {
            icon: <STATICS.BILL_CHECK />,
            label: 'Negociar pagamento',
            onClick: handleNegotiationRequest,
          },
        ]}
      >
        <p className='description'>Negocie suas faturas em aberto</p>
      </InfoCard>
    )
  }

  function renderNegotiationPortal() {
    return (
      <InfoCard
        title='Portal de negociações'
        actions={[
          {
            icon: <STATICS.MONEY_CHECK />,
            label: 'Acessar portal de negociação',
            onClick: handleNegotiationPortalRedirect,
          },
        ]}
      >
        <p className='description'>
          Para consulta de créditos disponíveis, acesse o portal de negociação
        </p>
      </InfoCard>
    )
  }

  return (
    <div className='canceled-contract-cards'>
      {renderNegotiationRequest()}
      <hr className='divider' />
      {renderNegotiationPortal()}
    </div>
  )
}
